import { A7ResourcesCommonModule } from '@ark7/resources-common';
import { A7SharedComponentsModule } from '@ark7/shared-components';
import { A7UiAuthModule } from '@ark7/ui-auth';
import { CommonModule } from '@angular/common';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { NgModule } from '@angular/core';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons/faAngleLeft';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons/faAngleRight';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons/faArrowLeft';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons/faArrowRight';

import { AboutComponent } from './pages/about/about.component';
import { HomeComponent } from './pages/home/home.component';
import { LogOnComponent } from './pages/log-on/log-on.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { WebV2PartsModule } from './parts/v2-parts.module';
import { WebV2RoutingModule } from './web-v2-routing.module';

@NgModule({
  imports: [
    WebV2RoutingModule,
    MatFormFieldModule,
    MatInputModule,
    CommonModule,
    MatDividerModule,
    WebV2PartsModule,
    A7UiAuthModule,
    A7ResourcesCommonModule,
    A7SharedComponentsModule,
  ],
  declarations: [
    HomeComponent,
    AboutComponent,
    SignUpComponent,
    LogOnComponent,
  ],
  exports: [HomeComponent, AboutComponent, SignUpComponent, LogOnComponent],
  providers: [],
})
export class WebV2Module {
  constructor(library: FaIconLibrary) {
    library.addIcons(faArrowLeft, faArrowRight, faAngleLeft, faAngleRight);
  }
}
